import { ExternalLink, Info } from "lucide-react";
import { useIsInIframe, openInTopWindow } from "../hooks/useIsInIframe";

/**
 * Shown on recording flows when the app is running inside an iframe
 * (e.g. the Emergent preview wrapper). Browsers block microphone access
 * inside iframes, so we prompt the user to open the app in a full browser tab.
 */
export default function MicIframeNotice({ accent = "#CBA153", className = "", theme = "dark" }) {
  const inIframe = useIsInIframe();
  if (!inIframe) return null;

  const textColor = theme === "light" ? "rgba(31,41,55,0.75)" : "rgba(245,240,230,0.75)";

  return (
    <div
      className={`rounded-2xl p-4 flex items-start gap-3 ${className}`}
      style={{
        background: `${accent}10`,
        border: `1px solid ${accent}33`,
      }}
      data-testid="mic-iframe-notice"
    >
      <Info size={14} strokeWidth={1.5} className="mt-0.5 flex-shrink-0" style={{ color: accent }} />
      <div className="flex-1 text-left">
        <p
          className="text-xs font-light leading-relaxed"
          style={{ color: textColor, fontFamily: "'Spectral', serif" }}
        >
          Recording is blocked here because this preview runs inside a frame. Open the app directly to record your voice.
        </p>
        <button
          onClick={openInTopWindow}
          className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-light tracking-wide underline-offset-4 hover:underline"
          style={{ color: accent }}
          data-testid="mic-iframe-open-btn"
        >
          Open in Safari
          <ExternalLink size={11} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
